import React, { useState, useEffect } from 'react';
import useColorSwatchStyles from './ColorSwatch.styles';

export interface ColorSwatchProps {
  value: string;
}

const validateColor = (value: string) => {
  if (typeof value !== 'string') {
    return false;
  }

  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && CSS.supports) {
    return CSS.supports('background-color', value);
  }

  // Fallback to simple regex checks if CSS.supports is not available (ex: Jest env and old browsers)
  return (
    /^#[0-9A-F]{6}$/i.test(value) ||
    /^rgb\(\d{1,3},\s?\d{1,3},\s?\d{1,3}\)$/i.test(value) ||
    /^rgba\(\d{1,3},\s?\d{1,3},\s?\d{1,3},\s?\d?\.?\d+\)$/i.test(value)
  );
};

export default function ColorSwatch({ value, ...otherProps }: ColorSwatchProps) {
  const {
    classes: { root },
  } = useColorSwatchStyles();

  const [isColorValid, setColorValid] = useState(false);

  useEffect(() => {
    const validated = validateColor(value);

    if (!validated && process.env.environment !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`Invalid ColorSwatch value, expected a valid CSS color, received '${value}'`);
    }

    setColorValid(validated);
  }, [value]);

  if (!isColorValid) {
    return null;
  }

  return <div className={root} {...otherProps} style={{ backgroundColor: value }} />;
}
